var _g, _rect, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAouImageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1429_871)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.552,
    cy: 17.6922,
    r: 16.512,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1429_871",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.39343,
    y: 7.26367,
    width: 20.8573,
    height: 20.8573,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1429_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7743 13.3471C26.5281 13.3471 26.3217 13.2638 26.1551 13.0973C25.9886 12.9307 25.9053 12.7243 25.9053 12.4781V11.609H25.0362C24.79 11.609 24.5836 11.5257 24.417 11.3592C24.2505 11.1926 24.1672 10.9862 24.1672 10.74C24.1672 10.4937 24.2505 10.2873 24.417 10.1208C24.5836 9.9542 24.79 9.87092 25.0362 9.87092H25.9053V9.00187C25.9053 8.75563 25.9886 8.54923 26.1551 8.38267C26.3217 8.2161 26.5281 8.13281 26.7743 8.13281C27.0206 8.13281 27.227 8.2161 27.3935 8.38267C27.5601 8.54923 27.6434 8.75563 27.6434 9.00187V9.87092H28.5124C28.7587 9.87092 28.9651 9.9542 29.1316 10.1208C29.2982 10.2873 29.3815 10.4937 29.3815 10.74C29.3815 10.9862 29.2982 11.1926 29.1316 11.3592C28.9651 11.5257 28.7587 11.609 28.5124 11.609H27.6434V12.4781C27.6434 12.7243 27.5601 12.9307 27.3935 13.0973C27.227 13.2638 27.0206 13.3471 26.7743 13.3471ZM18.9529 22.4722C20.0392 22.4722 20.9625 22.092 21.723 21.3316C22.4834 20.5711 22.8636 19.6478 22.8636 18.5614C22.8636 17.4751 22.4834 16.5518 21.723 15.7913C20.9625 15.0309 20.0392 14.6507 18.9529 14.6507C17.8665 14.6507 16.9432 15.0309 16.1828 15.7913C15.4223 16.5518 15.0421 17.4751 15.0421 18.5614C15.0421 19.6478 15.4223 20.5711 16.1828 21.3316C16.9432 22.092 17.8665 22.4722 18.9529 22.4722ZM18.9529 20.7341C18.3445 20.7341 17.8303 20.5241 17.4103 20.104C16.9902 19.684 16.7802 19.1698 16.7802 18.5614C16.7802 17.9531 16.9902 17.4389 17.4103 17.0189C17.8303 16.5988 18.3445 16.3888 18.9529 16.3888C19.5612 16.3888 20.0754 16.5988 20.4954 17.0189C20.9155 17.4389 21.1255 17.9531 21.1255 18.5614C21.1255 19.1698 20.9155 19.684 20.4954 20.104C20.0754 20.5241 19.5612 20.7341 18.9529 20.7341ZM12.0004 25.5139C11.5225 25.5139 11.1133 25.3437 10.7729 25.0033C10.4325 24.6629 10.2623 24.2537 10.2623 23.7758V13.3471C10.2623 12.8691 10.4325 12.46 10.7729 12.1196C11.1133 11.7792 11.5225 11.609 12.0004 11.609H14.738L15.8243 10.4358C15.9836 10.262 16.1755 10.1244 16.4 10.023C16.6245 9.92161 16.8599 9.87092 17.1061 9.87092H21.56C21.8062 9.87092 22.0126 9.9542 22.1792 10.1208C22.3458 10.2873 22.4291 10.4937 22.4291 10.74V12.0435C22.4291 12.4057 22.5558 12.7134 22.8093 12.9669C23.0628 13.2204 23.3705 13.3471 23.7326 13.3471H24.1672V13.7817C24.1672 14.1438 24.2939 14.4516 24.5474 14.705C24.8009 14.9585 25.1086 15.0852 25.4708 15.0852H26.7743C27.0206 15.0852 27.227 15.1685 27.3935 15.3351C27.5601 15.5017 27.6434 15.7081 27.6434 15.9543V23.7758C27.6434 24.2537 27.4732 24.6629 27.1328 25.0033C26.7924 25.3437 26.3833 25.5139 25.9053 25.5139H12.0004Z",
    fill: "#438D40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1429_871",
    x: 0.0400391,
    y: 0.180176,
    width: 41.024,
    height: 41.0239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1429_871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1429_871",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAouImageEdit);
export default __webpack_public_path__ + "static/media/aou-image-edit.9f0a8d359501be2b54aa741c2640234b.svg";
export { ForwardRef as ReactComponent };